
    import {Options} from 'vue-class-component';
    import {Vue} from 'vue-property-decorator';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import mutations from '@/profile-creation-wizard/store/completion/mutations';
    import getters from '@/profile-creation-wizard/store/completion/getters';

    @Options({
        components: {
            StepItemTitle,
        },
    })
    export default class AskForRecommendation extends Vue {
        $refs!: {
            recoText: HTMLTextAreaElement;
        };
        dataHeapTooltipID = 'profile-creation-tooltip-recommendations';
        recommmendationData = {
            recoEmails: '',
            recoTextToSend: '',
        };

        mounted(): void {
            this.bottomSheetDisplayer = new BottomSheetDisplayer(
                '#completion-recommendations-bottom-sheet',
                this.dataHeapTooltipID,
                this.$el,
                'div.profile-creation-wizard',
            );
            const currRecommendationData = this.$store.getters[getters.recommendations];

            if (!currRecommendationData.recoTextToSend) {
                this.$store.commit(mutations.setRecommendations, {recoTextToSend: this.defaultRecoText});
                currRecommendationData.recoTextToSend = this.defaultRecoText;
                this.emitRecoText({target: {value: this.defaultRecoText}});
            }

            this.recommmendationData = currRecommendationData;
        }

        openBottomSheet(): void {
            this.bottomSheetDisplayer.openBottomSheet();
        }

        emitRecoEmails(e: any): void {
            this.$emit('emailsChanged', e.target.value);
        }

        emitRecoText(e: any): void {
            this.$emit('textChanged', e.target.value);
        }

        get defaultRecoText(): string {
            return this.$msg('recommendation.defaultAskMessage');
        }

        get recoTextToSendJs(): string {
            return `{
                'm-textarea': {
                    autogrow: true,
                    displayCounter: true,
                    min: 0,
                    max: 2000
                }
            }`;
        }
    }
